<template>
  <router-view />
</template>

<script>
export default {
  name: 'contacerta-settings-layout',
  emits: ['loading'],
  created() {
    this.$emit('loading', false);
  }
};
</script>
